import { GET_SECTOR_HOTELS, GET_CITY_HOTELS } from '../graphql/queries/getHotel';
import { SET_SECTOR_HOTELS, SET_CITY_HOTELS, UPDATE_HOTEL_LOADING, SET_HOTEL_META } from './types';
import { store } from '../index';
import { history } from '../components/App';

 /**
 * Get sector hotels
 * 
 *  @param {object} client - Apollo client
 *  @param {string} uuid - Booking hash id
 *  @param {int} sectorId - sector id of the accommodation to modifiy
 */
export async function GetSectorHotel(client, uuid, sectorId){
    try{
        await store.dispatch({type:SET_SECTOR_HOTELS, payload:[]});
        await store.dispatch({type:UPDATE_HOTEL_LOADING, payload:true});

        await client.stop();
        const response = await client.query({query:GET_SECTOR_HOTELS, variables:{uuid:uuid, sectorId:sectorId}, fetchPolicy:"no-cache"});
        await store.dispatch({type:SET_SECTOR_HOTELS, payload:response.data.getSectorHotels});
        await store.dispatch({type:UPDATE_HOTEL_LOADING, payload:false});
        return response;
    }catch({graphQLErrors}){
        if(graphQLErrors !== undefined){
            await store.dispatch({type:UPDATE_HOTEL_LOADING, payload:false});
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    }
}

 /**
 * Get sector hotels
 * 
 *  @param {object} client - Apollo client
 *  @param {string} city - City name
 *  @param {string} date - checkin date
 *  @param {int} nights - nights number
 *  @param {string} currency - iso currency
 */
export async function GetCityHotel(client, city, date, nights, currency){
    try{
        await store.dispatch({type:SET_CITY_HOTELS, payload:[]});
        await store.dispatch({type:UPDATE_HOTEL_LOADING, payload:true});
        
        await client.stop();
        const response = await client.query({query:GET_CITY_HOTELS, variables:{city:city, date:date, nights:nights, currency:currency}, fetchPolicy:"no-cache"});
        await store.dispatch({type:SET_CITY_HOTELS, payload:response.data.getCityHotel});
        await store.dispatch({type:UPDATE_HOTEL_LOADING, payload:false});
        return response;
    }catch({graphQLErrors}){
        if(graphQLErrors !== undefined){
            await store.dispatch({type:UPDATE_HOTEL_LOADING, payload:false});
            
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    }
}


export function DeleteHotel(){
    return dispatch => {
        if(store.getState().hotel.sector.length > 0 || store.getState().hotel.city.length > 0){
            dispatch({type:SET_SECTOR_HOTELS, payload:[]});
            dispatch({type:SET_CITY_HOTELS, payload:[]});
        }
    }
}

export const SetHotelMeta = (value) => {
    return dispatch => dispatch({type:SET_HOTEL_META, payload:value})
  }